import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export const PLAN_EVENT = "plan-status-refresh";

export function usePlanStatus(enabled = true) {
  const [d, setD] = useState(null);
  useEffect(() => {
    if (!enabled) return undefined;
    const load = () => api.get("/plan/status").then((r) => setD(r.data)).catch(() => {});
    load();
    window.addEventListener(PLAN_EVENT, load);
    return () => window.removeEventListener(PLAN_EVENT, load);
  }, [enabled]);
  return d;
}

export const LIMIT_LABELS = { team: "Team-Mitglieder", avgs: "AVGS-Kunden", wb: "WB-Teilnehmer" };
export const fmtLimit = (v) => (v === null || v === undefined ? "∞" : v);
